"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchUserItem = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../../utils/classFunctions");
const dateTime_1 = require("../../../../../utils/dateTime");
const UserTypeIcon_1 = require("../../../../UserTypeIcon");
require("./index.scss");
const className = 'search-user-item';
const SearchUserItem = (props) => {
    const { userType, name, city, birthday, onClick, isSelected, } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        isSelected ? 'selected' : undefined,
        birthday ? undefined : 'without-birthday',
    ]);
    return (react_1.default.createElement("div", { className: classNames, onClick: onClick },
        react_1.default.createElement("div", { className: `${className}__title` },
            react_1.default.createElement("div", { className: `${className}__avatar` }, userType && (react_1.default.createElement(UserTypeIcon_1.UserTypeIcon, { userType: userType }))),
            react_1.default.createElement("div", { className: `${className}__name` }, name)),
        react_1.default.createElement("div", { className: `${className}__info` },
            birthday && (react_1.default.createElement("div", { className: `${className}__birthday` }, (0, dateTime_1.toInputDateString)(birthday))),
            react_1.default.createElement("div", { className: `${className}__city` }, city))));
};
exports.SearchUserItem = SearchUserItem;
//# sourceMappingURL=index.js.map